import { render } from "./ModalAllCustomer.vue?vue&type=template&id=0f845b48"
import script from "./ModalAllCustomer.vue?vue&type=script&lang=js"
export * from "./ModalAllCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__